import { useLocation } from 'react-router-dom'

import ConversationFlowDebugger from './ConversationFlowDebugger'
import DebugObservabilityLayout from './DebugObservabilityLayout'
import DebugSimulatorPage from './DebugSimulatorPage'

/**
 * /admin/debug/*
 *
 * We keep the existing Flow Debugger as-is for deep debugging,
 * and add operational subviews as nested routes to avoid breaking the workflow.
 */
export default function DebugAreaLayout() {
  const location = useLocation()
  const isSimulator = location.pathname.startsWith('/admin/debug/simulator')
  const isObservability =
    location.pathname.startsWith('/admin/debug/observability') ||
    location.pathname.startsWith('/admin/debug/alerts') ||
    location.pathname.startsWith('/admin/debug/funnel') ||
    location.pathname.startsWith('/admin/debug/conversations')

  if (isSimulator) {
    return <DebugSimulatorPage />
  }

  return isObservability ? <DebugObservabilityLayout /> : <ConversationFlowDebugger />
}
